/** Переключатель темы: солнце ↔ луна с поворотом (Mantine следует через `useMantineThemeSync`). */

import { AnimatePresence, motion } from 'framer-motion';

import { useThemeStore } from '../store/themeStore';
import { IconMoon, IconSun } from './icons';
import { useTranslation } from 'react-i18next';

export function ThemeToggle() {
  const { t } = useTranslation();
  const mode = useThemeStore((state) => state.mode);
  const toggle = useThemeStore((state) => state.toggle);
  const dark = mode === 'dark';
  return (
    <button
      type="button"
      onClick={toggle}
      aria-pressed={dark}
      aria-label={dark ? t('common.lightTheme') : t('common.darkTheme')}
      title={dark ? t('common.lightTheme') : t('common.darkTheme')}
      className="pointer-events-auto relative flex h-11 w-11 shrink-0 items-center justify-center overflow-hidden rounded-full border border-line bg-surface/95 text-heading shadow-soft backdrop-blur transition hover:bg-secondary"
    >
      <AnimatePresence mode="wait" initial={false}>
        <motion.span
          key={mode}
          initial={{ rotate: -90, scale: 0.4, opacity: 0 }}
          animate={{ rotate: 0, scale: 1, opacity: 1 }}
          exit={{ rotate: 90, scale: 0.4, opacity: 0 }}
          transition={{ type: 'spring', stiffness: 420, damping: 22 }}
          className="flex"
        >
          {dark ? <IconMoon size={18} stroke={2} aria-hidden="true" /> : <IconSun size={18} stroke={2} aria-hidden="true" />}
        </motion.span>
      </AnimatePresence>
    </button>
  );
}
